'use strict';
namespace init {
    $(document).ready(() => {
        initLoginPage();
        initValidation();
        setFroalaEditor($('.froala-editor'));
        initFrolaEditor();
        initAutoSubmitFileOnUpload();
        initTables();
        initPopover();
        initList();
        initFileUploadNameOnSelected();
    });

    function initTables() {
        var firstTd = "table tr td:first-child";
        $("<em class='fa'></em>").appendTo(firstTd);
        $(`${firstTd} em`).click((e) => {
            var collapseClass = "collapse";
            var expandLabel = "Expand item";
            var collapseLabel = "Collapse item";
            var button = $(e.target);
            var tableRow = button.parents("tr");
            tableRow.toggleClass(collapseClass);
            var ariaLabel = tableRow.hasClass(collapseClass) ? expandLabel : collapseLabel;
            button.attr("aria-label", ariaLabel);
        });
    }

    function initList() {
        var firstTd = "ul li div.firstDiv:first-child";
        $("<em class='fa' aria-label='Expand item' alt='Expand item' aria-expanded='false'></em>").appendTo(firstTd);
        $(`${firstTd} em`).click((e) => {
            var collapseClass = "collapse";
            var expandLabel = "Expand item";
            var collapseLabel = "Collapse item";
            var button = $(e.target);
            var liRow = button.closest("li");
            liRow.toggleClass(collapseClass);
            var hasRowClass = liRow.hasClass(collapseClass);
            var ariaLabel = hasRowClass? expandLabel : collapseLabel;
            button.attr("aria-label", ariaLabel);
            button.attr("aria-expanded", hasRowClass ? "false" : "true");
            button.attr("alt", ariaLabel);
        });
    }

    function initValidation() {
        if ($(".validation-summary-errors li").length > 0) {
            $(".validation-summary-errors li:first a").focus();
        }
    }
    
    function initAutoSubmitFileOnUpload() {
        var newFile = $("#newfile");
        if (newFile.length) {
            newFile.change(() => {
                $("#form").submit();
            });
        }
    }
    
    function initPopover() {
        $('[data-toggle="popover"]').popover({
            html: true,
            offset: '28px 142px'
        });
    }
    
    function initFrolaEditor()
    {
        var froalaEditJqueryObject = $(".froala.edit");
        var froalaEditorData = "froala.editor";
        var dataIdAttribute = "data-id";
        froalaEditJqueryObject.click((e) => {
            e.preventDefault();
            if ($(e.target).hasClass("fa")) {
                var target = $(e.target).parents(".froala");
            } else {
                var target = $(e.target);
            }
            var id = $(target).attr(dataIdAttribute);
            if (!$(`#${id}`).data(froalaEditorData)) {
                setFroalaEditor($(`#${id}`));
                $(target).addClass("hidden-xs-up");
                $(`.froala.update[data-id='${id}']`).removeClass("hidden-xs-up");
            }
        });
        var froalaUpdate = $(".froala.update");
        froalaUpdate.click((e) => {
            e.preventDefault();
            if ($(e.target).hasClass("fa")) {
                var target = $(e.target).parents(".froala");
            } else {
                var target = $(e.target);
            }
            var id = $(target).attr(dataIdAttribute);
            if ($(`#${id}`).data(froalaEditorData)) {
                $(`#${id}`).froalaEditor('destroy');
                $(target).addClass("hidden-xs-up");
                $(`.froala.edit[data-id="${id}"]`).removeClass("hidden-xs-up");
            }
        });
    }
    
    function setFroalaEditor(obj: object) {
        $(obj).froalaEditor({
            charCounterMax: 10000,
            toolbarButtonsXS: ['undo', 'redo', '|', 'bold', 'italic', 'formatUL'],
            toolbarButtonsSM: ['undo', 'redo', '|', 'bold', 'italic', 'formatUL'],
            toolbarButtonsMD: ['undo', 'redo', '|', 'bold', 'italic', 'formatUL'],
            toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'formatUL']
        });
    }

    function initLoginPage() {
        var $passwordToggle = $(".password-group span");
        $passwordToggle.attr("tabindex", 0);
        $passwordToggle.attr("role", "button");
        $passwordToggle.attr("aria-label", "Password visible toggle");
        $passwordToggle.keyup((e) => {
            e.preventDefault();
            if (e.keyCode === 13) {
                $passwordToggle.click();
            }
        });
    }

    function initFileUploadNameOnSelected() {
        $('input[type="file"]').change(function () {
            var name = '';
            var file = <HTMLInputElement>($(this)[0]);
            if (file && file.files && file.files.length > 0) {
                name = file.files[0].name;
            }
            $(this).parent().find('.custom-file-label').text(name);
        });
    }
}